// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1JSYM","paramInput":"JobSimulator_paramInput__2zlbi","input":"JobSimulator_input__2m--M"};